import Header from "../Header/Header";
import Main from "../Main/Main";
import Footer from "../Footer/Footer";
import React from "react";

export const LandingPage = () => (
    <>
        <Header/>
        <Main/>
        <Footer/>
    </>
)